/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { chatModelSchema } from "../chatModelSchema.ts";
import { z } from "zod";

export const getApiFeedbacksIdPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор чата")
    })

export const getApiFeedbacksIdQueryParamsSchema = z.object({
    "SearchQuery": z.string().describe("Строка поиска").optional(),
"Limit": z.coerce.number().int().describe("Пагинация - сколько необходимо получить элементов").optional(),
"Offset": z.coerce.number().int().describe("Пагинация - сколько необходимо пропустить элементов").optional()
    }).optional()

/**
 * @description Чат
 */
export const getApiFeedbacksId200Schema = z.lazy(() => chatModelSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const getApiFeedbacksId400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const getApiFeedbacksId401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const getApiFeedbacksId403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Чат не найден
 */
export const getApiFeedbacksId404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const getApiFeedbacksId500Schema = z.lazy(() => badResponseModelSchema)

export const getApiFeedbacksIdQueryResponseSchema = z.lazy(() => getApiFeedbacksId200Schema)